<template>
  <div class="incestgames">
    <h1>INCESTGAMES</h1>
    <Info
      :keyword="keyword || '全部'"
      :category="category || '全部'"
      :page="page"
      :totalPage="totalPage"
    ></Info>
    <Searcher @search="handleSearch" :showCategory="false"></Searcher>
    <Pager :page="page" :totalPage="totalPage" @changePage="handleChangePage"></Pager>
    <Incestgamesbody :docs="docs" :imgUrl="imgUrl" :token="token"></Incestgamesbody>
    <Searcher @search="handleSearch" :showCategory="false"></Searcher>
    <Pager :page="page" :totalPage="totalPage" @changePage="handleChangePage"></Pager>
    <Info
      :keyword="keyword || '全部'"
      :category="category || '全部'"
      :page="page"
      :totalPage="totalPage"
    ></Info>
  </div>
</template>

<script>
import $ from "jquery/dist/jquery.min.js";
import Info from "./Info";
import Searcher from "./Searcher";
import Pager from "./Pager";
import Incestgamesbody from "./Incestgamesbody";

export default {
  name: "Incestgames",
  props: {
    urlBase: String,
    token: String
  },
  components: {
    Info,
    Searcher,
    Pager,
    Incestgamesbody
  },
  data: function() {
    return {
      count: 0,
      keyword: "",
      page: 1,
      countPerPage: 12,
      docs: [],
    };
  },
  computed: {
    url: function() {
      return this.urlBase + "/incestgames";
    },
    totalPage: function() {
      return Math.ceil(this.count / this.countPerPage);
    },
    countUrl: function() {
      return this.url + "/count";
    },
    imgUrl: function() {
      return this.url + "/img/";
    }
  },
  created: function() {
    this.getCount();
    this.getContent();
  },
  methods: {
    getCount() {
      $.get(`${this.countUrl}?keyword=${this.keyword}`, { token: this.token })
        .then(result => {
          if (result.success) {
            this.count = result.count;
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    getContent() {
      $.get(
        `${this.url}?keyword=${this.keyword}&page=${this.page}&countPerPage=${this.countPerPage}`,
        { token: this.token }
      )
        .then(result => {
          if (result.success) {
            this.docs = result.docs;
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    handleSearch(filter) {
      this.keyword = filter.keyword || "";
      this.page = 1;
      this.getCount();
      this.getContent();
      window.scrollTo(0, 0);
    },
    handleChangePage(p) {
      this.page = p;
      this.getContent();
      window.scrollTo(0, 0);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}
h1 {
  text-align: center;
  font-family: cursive;
  text-shadow: #aaa 2px 2px 5px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.avzyz > details > summary {
  text-align: center;
}
</style>
